import { render } from "./FbAddTableColumn.vue?vue&type=template&id=2d7d9f28"
import script from "./FbAddTableColumn.vue?vue&type=script&lang=js"
export * from "./FbAddTableColumn.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__